export default __webpack_public_path__ + "static/media/91.53688451.png";